import type { MailboxInfo } from "owa-client-types";
import type { OutlookCloudPolicySettingId } from "../store/schema/OutlookCloudPolicyTypes";
import { isPoliciesEnabledForAccount } from "../utils/isPoliciesEnabledForAccount";
import { getPolicyDataBySettingId } from "./getPolicyDataBySettingId";

/**
 * Returns the raw OCPS policy value string for a setting, or undefined when policies are
 * disabled for the account or no policy data exists. Use this for enum/numeric valued policies
 * where the boolean isOcpsPolicyEnabled is insufficient.
 */
export function getOcpsPolicyValue(settingId: OutlookCloudPolicySettingId, mailboxInfo: MailboxInfo): string | undefined {
    if (!isPoliciesEnabledForAccount(mailboxInfo)) {
        return undefined;
    }
    return getPolicyDataBySettingId(mailboxInfo, settingId)?.value;
}

/**
 * Returns the OCPS policy value parsed as an integer, or undefined if absent or non-numeric.
 * Callers are responsible for validating the number against their target enum.
 */
export function getOcpsPolicyNumericValue(settingId: OutlookCloudPolicySettingId, mailboxInfo: MailboxInfo): number | undefined {
    const raw = getOcpsPolicyValue(settingId, mailboxInfo);
    if (raw === undefined) {
        return undefined;
    }
    const parsed = parseInt(raw, 10);
    return Number.isNaN(parsed) ? undefined : parsed;
}
